export const RegexUf = new RegExp(
  "(AC|AL|AP|AM|BA|CE|DF|ES|GO|MA|MT|MS|MG|PA|PB|PR|PE|PI|RJ|RN|RS|RO|RR|SC|SP|SE|TO)"
);
export const RegexPhone = RegExp(/\([1-9]{2}\)\s9[1-9]\d{3}-\d{4}/);

export const RegexPhoneFix = new RegExp("(?:[2-8]|9[1-9])[0-9]{3}-?[0-9]{4}$");
